import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { format, isToday } from 'date-fns';

@Pipe({
  name: 'customDate',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class CustomDatePipe implements PipeTransform {
  transform(value: string): string {
    const date = new Date(value);
    const today = new Date();

    // Check if the date is today
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    // Check if the date is from a different year
    const isDifferentYear = date.getFullYear() !== today.getFullYear();

    if (isToday) {
      // Format as "hours:minutes" (e.g., "11:57 AM")
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    } else if (isDifferentYear) {
      // Format as "short month day year hours:minutes" (e.g., "Nov 24, 2024 11:57 AM")
      return (
        date.toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
        }) +
        ` ${date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })}`
      );
    } else {
      // Format as "short month day hours:minutes" (e.g., "Nov 24 11:57 AM")
      return (
        date.toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
        }) +
        ` ${date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })}`
      );
    }
  }
}
